import * as Yup from 'yup';
import { TFunction } from 'i18next';

const initialValues = {
  name: '',
  website: '',
  contact_name: '',
  contact_email: '',
  contact_job_title: '',
  billing_email: '',
  lang: '',
  industry: '',
  address: '',
  logo: '',
  location: null,
  size: null
};

const validationSchema = (t: TFunction) => {
  return Yup.object({
    name: Yup.string().required(t('required')),
    website: Yup.string().test('isValidURL', t('invalid url'), (value) => {
      if (!value) {
        return true;
      }
      // If URL doesn't have protocol, add https:// prefix
      const urlWithProtocol = value.match(/^(https?|ftp):\/\//)
        ? value
        : `https://${value}`;
      return /^(ftp|http|https):\/\/[^ "]+$/.test(urlWithProtocol);
    }),
    contact_name: Yup.string(),
    contact_email: Yup.string().email(t('invalid email')),
    contact_job_title: Yup.string(),
    billing_email: Yup.string().email(t('invalid email')),
    lang: Yup.string().oneOf(['en', 'nl']),
    industry: Yup.mixed(),
    address: Yup.string(),
    logo: Yup.string(),
    location: Yup.mixed().nullable(),
    size: Yup.mixed().nullable()
  });
};

export { validationSchema, initialValues };
